import { privateApi, privateBlobApi } from "@core/libs/axios/apiInstances";
import { handleResponse } from "@core/libs/axios/serviceHandler";
import type { TBulkDownloadPayload } from "@modules/docs/documents/types/delete/TBulkDocs";
import type { TDocDownload } from "@modules/docs/documents/types";

export async function downloadSingleFile(
  workspaceId: string,
  projectId: string,
  fileId: string,
  signal?: AbortSignal,
): Promise<TDocDownload> {
  return handleResponse<TDocDownload>(
    privateApi.get(
      `/documents/${workspaceId}/${projectId}/files/${fileId}`,
      { signal },
    ),
  );
}

export async function downloadFolder(
  workspaceId: string,
  projectId: string,
  folderId: string,
): Promise<Blob> {
  return privateBlobApi.get(
    `/documents/${workspaceId}/${projectId}/folders/${folderId}/download`,
  );
}

export async function downloadBulkDocs(
  workspaceId: string,
  projectId: string,
  payload: TBulkDownloadPayload,
  folderId: string,
): Promise<Blob> {
  return privateBlobApi.post(
    `/documents/${workspaceId}/${projectId}/${folderId}/folders/download-many`,
    payload,
  );
}
